/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import MyPuratosArea from '../ecom/MyPuratosArea';
import { RoleMatrix } from '../ecom/RoleMatrix';
import { ROLES } from '../../../data/user.model';
import Link from '../../atoms/text/Link';
import { connect } from 'react-redux';
import { redirectToLogin } from '../../../actions/auth';
import { requestPrice } from '../../../actions/my-puratos/requestPrice.action';
import { googleEvents } from '../../../utils/googleEvents';

class _FavoriteRecipeIcon extends React.Component {
    render() {
        const { active, toggle, redirectToLogin, googleData } = this.props;

        const onClick = (e) => {
            e.preventDefault();
            if (!active) {
                googleEvents.recipeLike(googleData);
            }
        };

        return (
            <MyPuratosArea requireEcom requireFavoriteRecipes>
                <RoleMatrix>
                    <Link roles={ROLES.loggedOut} onClick={redirectToLogin}>
                        <span className="btn-fav btn-fav-empty" />
                    </Link>
                    <Link roles={ROLES.connected} onClick={toggle}>
                        <span
                            className={`btn-fav btn-fav${
                                active ? '' : '-empty'
                            }`}
                            onClick={onClick}
                        />
                    </Link>
                </RoleMatrix>
            </MyPuratosArea>
        );
    }

    static propTypes = {
        active: PropTypes.bool,
        toggle: PropTypes.func,
        redirectToLogin: PropTypes.func,
    };
}

export const FavoriteRecipeIcon = connect(undefined, { redirectToLogin })(
    _FavoriteRecipeIcon
);
